import {gql} from 'apollo-angular';

export const GET_ROOKIE_DAY_PROVIDER_REGISTER_TIME = gql`
  query RookieDayProviderRegisterTime($districtId: Int!) {
    rookiedayProviderRegisterTime(districtId: $districtId) {
      openAt
      closeAt
    }
  }
`;
